export interface StepSection {
  title: string;
  description: string;
}

const ABOUT_YOU_DESCRIPTION =
  "Let's start by understanding your current situation and goals to create a personalized tax service package.";

export const CONTACT_DETAILS_DESCRIPTION =
  "Entering your details allows us to work our magic and put together the recommended features for your perfect engagement.";

const STEP_SECTIONS: Record<string, StepSection> = {
  "About You": { title: "About you", description: ABOUT_YOU_DESCRIPTION },
  "Cash Flow": {
    title: "Cash flow",
    description:
      "Help us understand your cash flow goals and priorities to optimize your financial management."
  },
  "Tax Savings": {
    title: "Tax savings",
    description:
      "Let's identify your tax optimization goals and how you'd like to use your potential savings."
  },
  "Career Needs": {
    title: "Career needs",
    description:
      "Tell us about your professional goals and any business ventures you're considering or planning."
  },
  "Business Needs": {
    title: "Business needs",
    description:
      "Tell us about your business goals and the support you need to run and grow it."
  },
  Savings: {
    title: "Savings",
    description:
      "Let us know how you'd like to put your tax savings to work for your future goals."
  },
  Reporting: {
    title: "Reporting",
    description:
      "Choose the reporting and support services you need for your tax compliance and planning."
  },
  Summary: {
    title: "Your recommended package options",
    description: "Select the option that best suits your needs"
  }
};

export const getStepSection = (label?: string): StepSection | null =>
  (label && STEP_SECTIONS[label]) || null;
